import React, { useEffect } from 'react';
import { Modal, Box } from '@mui/material';

const CustomModal = (props) => {
    const { modalOpen, component,backgroundColor,backdropFilter, onClose,data_test_id } = props;

    useEffect(() => {
        if (modalOpen) {
            document.documentElement.style.overflowY = 'hidden';
        } else {
            document.documentElement.style.overflowY = 'auto';
        }
        return () => {
            document.documentElement.style.overflowY = 'auto';
        };
    }, [modalOpen]);

    return (
        <>
            <Modal
                open={modalOpen}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{ overflow: 'hidden',backgroundColor: backgroundColor,
                backdropFilter: backdropFilter}}
                onClose={onClose}
                data-testid={data_test_id}
            >
                <Box sx={{
                    overflow: 'hidden',
                    padding: '20px',
                }}>
                    {component}
                </Box>
            </Modal>
        </>
    );
};

export default CustomModal;
